import { createSelector } from 'reselect';
import { initialState } from './reducer';

/**
 * Direct selector to the absenceMobile state domain
 */

const selectAbsenceMobileDomain = state => state.absenceMobile || initialState;

/**
 * Other specific selectors
 */

/**
 * Default selector used by AbsenceMobile
 */

const selectAbsenceMobileData = () =>
  createSelector(
    selectAbsenceMobileDomain,
    substate => substate.absenceData,
  );

const selectAbsenceMobileList = () =>
  createSelector(
    selectAbsenceMobileDomain,
    substate => substate.absenceList,
  );

const selectAbsenceMobileLoading = () =>
  createSelector(
    selectAbsenceMobileDomain,
    substate => substate.loading,
  );

const selectAbsenceMobileError = () =>
  createSelector(
    selectAbsenceMobileDomain,
    substate => substate.error,
  );

const selectAbsenceMobileDeleteSuccessful = () =>
  createSelector(
    selectAbsenceMobileDomain,
    substate => substate.deleteSuccessful,
  );

export {
  selectAbsenceMobileDomain,
  selectAbsenceMobileLoading,
  selectAbsenceMobileError,
  selectAbsenceMobileDeleteSuccessful,
  selectAbsenceMobileData,
  selectAbsenceMobileList,
};
